import React from 'react';
import { useHistory } from 'react-router-dom';
import VenueForm from 'forms/VenueForm';
import EditVenueContext from 'contexts/EditVenueContext';
import { getVenue } from 'services/venuesServices';
import { loadImages } from 'services/imageServices';
import Venue from 'types/models/Venue';

export default (): JSX.Element => {
  const history = useHistory();
  const { selectedVenue } = React.useContext(EditVenueContext);
  const [completeVenue, setCompleteVenue] = React.useState<Venue | null>(null);

  const load = React.useCallback(async (id: string) => {
    const venue = await getVenue(id);
    if (!venue) {
      history.push('/private/venues');
      return;
    } else {
      if (venue.images) {
        await loadImages(venue.images);
      }
    }
    setCompleteVenue(venue);
  }, []);

  React.useEffect(() => {
    if (!selectedVenue) {
      history.push('/private/venues');
    } else {
      load(selectedVenue.id);
    }
  }, [selectedVenue]);

  if (!completeVenue) return <></>;
  return <VenueForm venue={completeVenue} />;
};
